<template>
  <div class="text-base-content/50 overflow-auto">
    <div class="pt-2 px-4">
      <!-- 游戏名称 -->
      <div>
        <div class="flex items-center justify-between mt-3 mb-2">
          <h2 class="text-base font-bold">
            {{ $t("game.base.name") }}
            <span class="text-[#E84B4B]">*</span>
          </h2>
          <button
            class="btn btn-xs rounded"
            @click="
              router.push({
                name: 'galGameDetail',
                params: { uuid: store.galGameUUID },
              })
            "
          >
            {{ $t("game.toGameDetailPage") }}
          </button>
        </div>
        <VanField
          v-model="store.form.name"
          :placeholder="$t('game.pleaseEnterGameName')"
          class="bg-base-100 border rounded"
          required
          @blur="store.saveBase"
        />
      </div>

      <!-- 类型 -->
      <div>
        <div class="flex items-center justify-between mt-3 mb-2">
          <h2 class="text-base font-bold">
            {{ $t("game.base.type") }}
            <span class="text-[#E84B4B]">*</span>
          </h2>
        </div>

        <VanField
          v-model="type"
          :placeholder="$t('game.typePlaceholder')"
          class="bg-base-100 border rounded"
          is-link
          name="picker"
          readonly
          required
          @click="showSelectType = true"
        />
      </div>

      <!-- 游戏简述 -->
      <div>
        <div class="flex items-center justify-between mt-3 mb-2">
          <h2 class="text-base font-bold">
            {{ $t("game.base.description") }}
            <span class="text-[#E84B4B]">*</span>
          </h2>

          <div>
            <!-- <button class="btn  btn-xs rounded mr-2">
            清空
          </button> -->
            <button
              class="btn btn-xs rounded"
              @click="store.clickAutoGenerate('description')"
            >
              {{ $t(`story.auto`) }}
            </button>
          </div>
        </div>

        <VanField
          v-model="store.form.description"
          :autosize="{ minHeight: 100 }"
          rows="1"
          type="textarea"
          @blur="store.saveBase"
        />
      </div>

      <div>
        <div class="flex items-center justify-between mt-3 mb-2">
          <h2 class="text-base font-bold">
            {{ $t("game.base.cover") }}
            <span class="text-[#E84B4B]">*</span>
          </h2>
        </div>

        <div class="text-center">
          <UserAvatar
            :avatar-url="store.form.coverMedia?.url"
            aspect="16/9"
            class="object-cover w-full mb-2"
            high-quality
          />

          <button
            class="btn btn-sm rounded w-[16rem]"
            @click="store.clickOpenUploadModal(1)"
          >
            <i class="iconify mingcute--edit-3-line mt-[-1px]"></i>
            {{ $t("Buttons.replace") }}
          </button>
        </div>
      </div>

      <div class="text-center">
        <div class="flex items-center justify-between mt-3 mb-2">
          <h2 class="text-base font-bold">
            {{ $t("game.videoAndScreenshot") }}
          </h2>
        </div>

        <div
          v-for="(mediaId, idx) in store.mediaList"
          class="bg-my-dark gap-2 text-center mb-2"
        >
          <UserAvatar
            v-if="store.mediaMap[mediaId].type === 1"
            :avatar-url="store.mediaMap[mediaId].url"
            aspect="16/9"
            class="object-cover w-full"
            high-quality
          />
          <video
            v-else
            :poster="store.mediaMap[mediaId].videoCoverUrl"
            :src="store.mediaMap[mediaId].url"
            controls
            crossorigin="anonymous"
          />
          <div class="flex justify-between items-center px-3 py-2.5">
            <button
              class="btn btn-primary"
              @click="clickShowMediaType(mediaId)"
            >
              <i class="iconify mingcute--edit-3-line"></i>
              {{ $t("Buttons.replace") }}
            </button>
            <div class="flex gap-1">
              <button
                v-if="idx !== 0"
                class="btn btn-primary rounded border-none"
                @click="clickSort(mediaId, true)"
              >
                <i class="iconfont icon-up text-xs" />
              </button>
              <button
                v-if="idx !== store.mediaList.length - 1"
                class="btn btn-primary rounded border-none"
                @click="clickSort(mediaId, false)"
              >
                <i class="iconfont icon-down text-xs" />
              </button>
              <button
                class="btn btn-primary rounded border-none"
                @click="store.deleteMedia(mediaId)"
              >
                <i class="iconfont icon-delete text-xs" />
              </button>
            </div>
          </div>
        </div>

        <button
          class="btn btn-sm rounded w-[16rem] mx-auto mb-2"
          @click="clickShowMediaType()"
        >
          <i class="iconfont icon-a- mt-[-1px]"></i>
          {{ $t("Buttons.add") }}
        </button>
      </div>
    </div>

    <modal-select-collection
      :selected="store.form.collectionIdzz"
      @confirm="onConfirmCollection"
    />
  </div>

  <VanPopup v-model:show="showSelectType" position="bottom">
    <VanPicker
      :cancel-button-text="$t('Buttons.cancel')"
      :columns="columns"
      :confirm-button-text="$t('Buttons.momentSave')"
      @cancel="showSelectType = false"
      @confirm="onConfirmSelectGameType"
    />
  </VanPopup>

  <VanActionSheet
    v-model:show="showSelectMediaType"
    :actions="actions"
    :cancel-text="$t('Buttons.cancel')"
    close-on-click-action
    @select="onSelectMediaType"
  />
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";
import { PickerConfirmEventParams } from "vant";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const store = useGalGameEditor();
const router = useRouter();

const { t } = useI18n();

// game type
const showSelectType = ref(false);
const columns = [
  {
    value: 1,
    text: t(`game.type.1`),
  },
  {
    value: 2,
    text: t(`game.type.2`),
  },
  {
    value: 3,
    text: t(`game.type.3`),
  },
];

const showSelectMediaType = ref(false);
const actions = [
  { name: t(`Buttons.uploadImage`), value: "img" },
  { name: t(`Buttons.uploadVideo`), value: "video" },
];
const onSelectMediaType = (item: any) => {
  store.mediaType = item.value as "img" | "video";
  store.uploadType = 2;
  store.showImgUploadModal = true;
};
const clickShowMediaType = (activeMediaId?: number) => {
  store.activeMediaId = activeMediaId;
  showSelectMediaType.value = true;
};

const onConfirmSelectGameType = (value: PickerConfirmEventParams) => {
  store.form.type = value.selectedOptions[0]!.value! as 1 | 2 | 3;
  showSelectType.value = false;
  store.saveBase();
};

const type = computed(() => t(`game.type.${store.form.type}`));

// img upload

const clickSort = (id: number, isUp: boolean) => {
  const idx = store.mediaList.findIndex((mediaId) => mediaId === id);
  if (isUp) {
    const prev = store.mediaList[idx - 1];
    store.mediaList[idx - 1] = id;
    store.mediaList[idx] = prev;
  } else {
    const next = store.mediaList[idx + 1];
    store.mediaList[idx + 1] = id;
    store.mediaList[idx] = next;
  }
  store.sortMedia();
};

// 合集相关
const onConfirmCollection = (idList: number[]) => {
  store.form.collectionIdzz = idList;
  store.saveBase();
};
</script>

<style scoped>
/* Your CSS code goes here */
</style>
